import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MessageCircleQuestion } from "lucide-react";

const faqs = [
  {
    question: "How is Reqqy different from just asking ChatGPT?",
    answer:
      "Reqqy is purpose-built for requirements analysis. It uses specialized prompts tuned for PM workflows, provides structured clarity scores, integrates with Jira, and offers enterprise security features like zero-retention mode. It's not a general-purpose AI—it's a focused tool for one job: making requirements clearer.",
  },
  {
    question: "Will this replace my PM role?",
    answer:
      "No. Reqqy is designed to be your junior PM assistant, not your replacement. It handles the tedious work of reviewing requirements for ambiguity so you can focus on strategy, stakeholder alignment, and decision-making. Think of it as a force multiplier.",
  },
  {
    question: "How long does it take to review requirements?",
    answer:
      "Quick analysis takes about 30 seconds. Deep analysis with improvement suggestions takes 1-2 minutes. Either way, it's faster than waiting for engineers to point out issues during sprint planning.",
  },
  {
    question: "Can I integrate with my existing tools?",
    answer:
      "Yes. Reqqy integrates with Jira for exporting improved requirements with the Reqqy-reviewed label. We're adding Aha, Confluence, Linear, and Notion integrations soon. Enterprise plans can request custom integrations.",
  },
  {
    question: "What about data privacy and security?",
    answer:
      "By default, data is stored for your convenience so you can reference past reviews. You can enable Temporary Mode for ephemeral sessions where nothing is saved. Enterprise plans offer zero-retention execution with SOC 2 Type II compliant infrastructure.",
  },
  {
    question: "Is there a free trial?",
    answer:
      "Yes. You receive 10 free credits monthly on the Free plan (no CC required). This gives you enough to see the value before committing to a paid plan.",
  },
];

export function FAQSection() {
  return (
    <section className="py-20 md:py-32 relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute top-[30%] left-[20%] w-[400px] h-[400px] rounded-full bg-accent/[0.04] blur-[140px]" />

      <div className="container relative z-10 px-4 md:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            <MessageCircleQuestion className="w-4 h-4" />
            FAQ
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
            Frequently asked questions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to know about Reqqy
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="group rounded-xl glass border border-border/30 px-6 transition-all duration-300 hover:border-primary/15 data-[state=open]:border-primary/20 data-[state=open]:shadow-[0_4px_24px_-8px_hsl(var(--primary)/0.08)]"
              >
                <AccordionTrigger className="text-left hover:no-underline py-5 [&[data-state=open]>svg]:text-primary">
                  <span className="font-medium transition-colors duration-200 group-hover:text-foreground">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
